import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { graphql, withApollo } from 'react-apollo'
import URL from 'url-parse'
import getCartItemsFromCache from 'graphql/getCartItemsFromCache'
import getMayflyData from 'graphql/getMayflyData'
import { log } from 'utils/error-tracking'
import { Cart } from 'components/cart'
import { flowRight as compose } from 'lodash'

class CartBasket extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      cartItems: PropTypes.array,
    }).isRequired,
    client: PropTypes.object,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    if (this.props.location.pathname === '/success') {
      this.state = {
        cartId: null,
        cartItems: [],
      }
      return null
    }
    this.stripCartKey()
    this.state = {
      cartId: localStorage.getItem('cart_id'),
      cartItems: this.props.data.cartItems,
    }
    // TODO: this can potentially be moved into graphql-compose
    this.getCartItemsFromMayFly()
  }

  componentDidUpdate(prevProps, prevState) {
    function _list(items) {
      return items
        .map(item => Array(item.quantity).fill(item.sku))
        .reduce((flat, list) => flat.concat(list), [])
        .sort()
        .join('')
    }

    if (_list(prevProps.data.cartItems) !== _list(this.props.data.cartItems)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ cartItems: this.props.data.cartItems })
    }

    if (this.props.location.pathname === '/success') return null

    const cartId = localStorage.getItem('cart_id')
    if (prevState.cartId !== cartId) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ cartId })
      this.getCartItemsFromMayFly()
    }
    return null
  }

  stripCartKey() {
    const url = new URL(window.location, true)
    if (!url.query) return null
    if (!url.query.mfKey) return null

    localStorage.setItem('cart_id', url.query.mfKey)

    delete url.query.mfKey
    url.set('query', { ...url.query })
    const urlWoCacheKey = url.href.substring(
      url.href.indexOf(this.props.location.pathname),
      url.href.length,
    )
    return this.props.history.push(urlWoCacheKey)
  }

  getCartItemsFromMayFly() {
    // restore data from mayfly to in-memory cache
    const mfKey = this.state.cartId
    if (!mfKey) return null
    return this.props.client
      .query({
        query: getMayflyData,
        variables: { mfKey },
      })
      .then(data => {
        const cartItems = data.data.getMayflyData
        this.props.client.writeData({ data: { cartItems } })
        this.setState({ cartItems })
      })
      .catch(() => {
        log({
          file: 'cart-basket',
          err: {
            stack: `Exception when read cart info from Mayfly, mfKey: ${mfKey}`,
          },
        })
      })
  }

  render() {
    return (
      <Cart
        href={`/cartsummary${window.location.search}`}
        isActive={this.props.location.pathname === '/cartsummary'}
        label={this.state.cartItems.reduce(
          (sum, item) => sum + item.quantity,
          0,
        )}
        name="CartSummary"
        data-pagename="main:consumer:gifts:home:"
        data-pagename2="main:consumer:gifts:home::::"
      />
    )
  }
}

const CartBasketWithData = compose(
  withApollo,
  withRouter,
  graphql(getCartItemsFromCache),
)(CartBasket)

export default CartBasketWithData
